import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

export default function ThemeToggle({ className = "" }: { className?: string }) {
  const { theme, toggleTheme } = useTheme();
  const dark = theme === "dark";

  return <button type="button" className={`theme-toggle ${className}`} onClick={toggleTheme} title={dark ? "切换到明亮模式" : "切换到黑暗模式"} aria-label={dark ? "切换到明亮模式" : "切换到黑暗模式"} aria-pressed={dark}>{dark ? <Sun size={18} /> : <Moon size={18} />}</button>;
}
